import React, { useState } from "react";
import { FaArrowRight, FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";

const NavbarTwo = () => {
  const [active, setActive] = useState(false);
  const [searchShow, setSearchShow] = useState(false);
  const menuActive = () => {
    setActive(!active);
  };
  const searchActive = () => {
    setSearchShow(!searchShow);
    console.log("hell");
  };

  // Control sidebar navigation
  let items = document.querySelectorAll(".menu-item-has-children > a");
  for (let i in items) {
    if (items.hasOwnProperty(i)) {
      items[i].onclick = function () {
        this.parentElement
          .querySelector(".sub-menu")
          .classList.toggle("active");
        this.classList.toggle("open");
      };
    }
  }
  return (
    <>
      {/* search popup start*/}
      <div
        className={searchShow ? "td-search-popup active" : "td-search-popup "}
        id="td-search-popup"
      >
        <form action="/" className="search-form">
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              placeholder="Search"
            />
          </div>
          <button type="submit" className="submit-btn">
            <FaSearch />
          </button>
        </form>
      </div>
      {/* search popup end*/}
      <div
        onClick={searchActive}
        className={searchShow ? "body-overlay active" : "body-overlay"}
        id="body-overlay"
      ></div>
      {/* ==================== Navbar Two Start ====================*/}
      <nav className="navbar navbar-area navbar-area-2 navbar-expand-lg nav_bg">
        <div className="container nav-container">
          <div className="responsive-mobile-menu">
            <button
              onClick={menuActive}
              className={
                active
                  ? "menu toggle-btn d-block d-lg-none open"
                  : "menu toggle-btn d-block d-lg-none"
              }
              data-target="#itech_main_menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-left" />
              <span className="icon-right" />
            </button>
          </div>
          <div className="logo">
            <Link to="/">
              <p>
                <span style={{ color: "#414141" }}>Evolve</span>
                <span style={{ color: "#4faf9b" }}>Lab</span>
              </p>
            </Link>
          </div>
          <div className="nav-right-part nav-right-part-mobile">
            <span className="search-bar-btn" onClick={searchActive}>
              <FaSearch />
            </span>
          </div>
          <div
            className={
              active
                ? "collapse navbar-collapse sopen"
                : "collapse navbar-collapse"
            }
            id="itech_main_menu"
          >
            <ul className="navbar-nav menu-open text-lg-center">
              <li>
                <Link className="links" to="/">
                  Home
                </Link>
              </li>
              <li>
                <Link className="links" to="/about">
                  About
                </Link>
              </li>
              <li className="menu-item-has-children">
                <button
                  type="button"
                  className="links"
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Funding
                </button>
                <ul className="sub-menu">
                  <li>
                    <Link to="/funding/jumpstart">Fund Jumpstart</Link>
                  </li>
                  <li>
                    <Link to="/funding/boost">Fund Boost</Link>
                  </li>
                  <li>
                    <Link to="/funding/advisory">Fund Advisory</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <button
                  type="button"
                  className="links"
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Accelerator
                </button>
                <ul className="sub-menu">
                  <li>
                    <Link to="/accelerator/dev-sprint">Dev Sprint</Link>
                  </li>
                  <li>
                    <Link to="/accelerator/dev-build">Dev Build</Link>
                  </li>
                  <li>
                    <Link to="/accelerator/dev-scale">Dev Scale</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link className="links" to="/fundinglab">
                  Funding Lab
                </Link>
              </li>
              <li>
                <Link className="links" to="/portfolio">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link className="links" to="/careers">
                  Careers
                </Link>
              </li>
              <li>
                <Link className="links" to="/contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="nav-right-part nav-right-part-desktop align-self-center">
            <Link
              className="btn btn-base-color border-radius-5 d-flex align-items-center"
              to="/apply"
            >
              Apply <FaArrowRight className="mt-0" />
            </Link>
          </div>
        </div>
      </nav>
      {/* ==================== Navbar Two end ====================*/}
    </>
  );
};

export default NavbarTwo;
